import { t } from "@/i18n-js/instance";
import { Collapsible } from "@/react/components/shared/uikit/Collapsible";
import { BoxModelInput } from "@circle-react-shared/BuilderUI/Editor/fields/BoxModelField";

export const Margin = () => (
  <Collapsible title={t("builder_ui.prop_type.styles.margin")} defaultOpen>
    <div className="px-6 pb-5">
      <BoxModelInput
        type="margin"
        name="styles.margin"
        label={t("builder_ui.prop_type.styles.margin")}
      />
    </div>
  </Collapsible>
);
